import type {
	LighthouseAuditDetails,
	LighthouseCategory,
} from "../types/analyzer";

interface AccessibilityProps {
	accessibilityCategory: LighthouseCategory;
	audits: Record<string, LighthouseAuditDetails>;
}

function Accessibility({
	accessibilityCategory,
	audits,
}: AccessibilityProps) {
	const auditRefs = accessibilityCategory.auditRefs ?? [];

	if (!auditRefs.length) {
		return null;
	}

	return (
		<section id="accessibility" className="results-section">
			<header className="results-section__header">
				<div>
					<p className="eyebrow">Accessibility</p>
					<h3>Lista priorizada de mejoras rápidas</h3>
				</div>
			</header>
			<div className="audit-stack audit-stack--grid">
				{auditRefs.map((audit) => {
					const auditDetail = audits[audit.id];
					if (!auditDetail) {
						return null;
					}
					return (
						<div key={audit.id} className="audit-chip">
							<p className="audit-chip__title">{audit.id.replaceAll("-", " ")}</p>
							<p className="audit-chip__description">
								{auditDetail.description.replace(/\[.*/, "")}
							</p>
						</div>
					);
				})}
			</div>
		</section>
	);
}

export default Accessibility;
